import React, { memo } from 'react'
import {
  FormControlLabel,
  Box,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import { toggleValueFromString } from 'utils/universal'
import CheckIcon from 'public/img/easy/Check-icon.svg'
import sx from './styles'

const filterOptions = [
  {
    id: 'cdmx', label: 'Cdmx y Edo Mex', value: '32', visible: process.env.NEXT_PUBLIC_APP_ENV === 'production',
  },
  {
    id: 'queretaro', label: 'Querétaro', value: '36', visible: process.env.NEXT_PUBLIC_APP_ENV === 'production',
  },
  {
    id: 'cdmx', label: 'Cdmx y Edo Mex', value: '12', visible: process.env.NEXT_PUBLIC_APP_ENV !== 'production',
  },
  {
    id: 'queretaro', label: 'Querétaro', value: '14', visible: process.env.NEXT_PUBLIC_APP_ENV !== 'production',
  },
].filter((({ visible }) => visible))

const StateFilter = ({ branchSelected, onChange }) => {
  const handleChange = (branch) => {
    let formattedName = ''
    if (branch === '32' || branch === '12') {
      const agencyExterna = process.env.NEXT_PUBLIC_APP_ENV === 'production'
        ? '45' : '15'
      const addEdoMex = toggleValueFromString(branchSelected, agencyExterna)
      formattedName = toggleValueFromString(addEdoMex, `${branch}`)
    } else {
      formattedName = toggleValueFromString(branchSelected, branch)
    }
    onChange(({ branch_id: formattedName }))
  }

  const handleIsChecked = (value) => {
    return branchSelected?.includes(value)
  }

  return (
    <Grid
      container
      gap={1}
      sx={sx.root}
    >
      {filterOptions
        && filterOptions?.map(({ label, value }) => (
          <Grid
            size="grow"
            sx={sx.item}
            key={`state-${label}`}
          >
            <FormControlLabel
              sx={sx.field}
              control={(
                <Box sx={sx.checkContainer}>
                  {
                    (handleIsChecked(value)) ? (
                      <CheckIcon />
                    ) : (
                      <Box sx={sx.emptyCheck} />
                    )
                  }
                </Box>
              )}
              onClick={() => handleChange(value)}
              label={(
                <Typography
                  variant="button-text"
                  sx={sx.text}
                >
                  {label}
                </Typography>
              )}
            />
            {/* <FormControlLabel
              key={id}
              control={(
                <Checkbox
                  onChange={(e) => handleChange(e, value)}
                  checked={handleIsChecked(value)}
                />
              )}
              label={label}
            /> */}
          </Grid>
        ))}
    </Grid>
  )
}

export default memo(StateFilter)
